import { helper } from '@ember/component/helper';

import { and } from 'rise-ui/utils/choice.js';

export default helper(function andHelper(params) {
  return and(...params);
});
